function lastUpdated(onlyDate) {
  return onlyDate
    ? new Date().toLocaleTimeString(navigator.language, {
        hour: '2-digit',
        minute: '2-digit',
      })
    : `Last Updated ${new Date().toLocaleTimeString(navigator.language, {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
}

export default lastUpdated;
